<template>
  <v-card
    class="ma-0 px-1"
    width="100%"
    flat
  >
    <v-progress-linear
      :active="!render"
      :indeterminate="!render"
      absolute
      bottom
      style="top: -4px"
      color="primary"
    />
    <v-form
      v-if="render"
      ref="form"
      v-model="valid"
      lazy-validation
    >
      <v-container>
        <v-row class="mb-3">
          <v-col md="1">
            <v-checkbox
              v-model="paymentZibalSystem"
              class="mt-0"
              :label="(paymentZibalSystem == 'active' ? $t('active') : $t('deactive'))"
              value="active"
            />
          </v-col>
          <v-col
            cols="12"
            md="11"
          >
            <v-text-field
              v-model="paymentZibalApiKey"
              :label="$t('API KEY')"
              outlined
              clearable
              dense
            />
          </v-col>
          <v-col
            cols="12"
            md="5"
          >
            <v-text-field
              v-model="paymentZibalAccountName"
              :label="$t('accountOwnerName')"
              :rules="[v => !!v || $t('is-required')]"
              outlined
              placeholder="IR..."
              clearable
              dense
            />
          </v-col>
          <v-col
            cols="12"
            md="7"
          >
            <v-text-field
              v-model="paymentZibalAccountShaba"
              :label="$t('shabaNumber')"
              :rules="[v => !!v || $t('is-required')]"
              outlined
              placeholder="IR..."
              clearable
              dense
            >
              <template v-slot:append>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon
                      v-if="paymentZibalConfirm !== 'confirm' || !paymentZibalConfirm"
                      v-bind="attrs"
                      color="pink"
                      v-on="on"
                    >
                      mdi-clock-check-outline
                    </v-icon>
                  </template>
                  <span>{{ $t('awaitingApproval') }}</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon
                      v-if="paymentZibalConfirm == 'confirm'"
                      v-bind="attrs"
                      color="green"
                      v-on="on"
                    >
                      mdi-check
                    </v-icon>
                  </template>
                  <span>{{ $t('confirmed') }}</span>
                </v-tooltip>
              </template>
            </v-text-field>
          </v-col>
          <v-col
            cols="12"
            md="5"
          >
            <autocomplete
              v-model="paymentZibalBank"
              :title="$t('bank') + '/' + $t('cash')"
              type="allBankCash"
              :filter="false"
            />
          </v-col>
        </v-row>
      </v-container>
      <v-card-actions>
        <v-row class="ma-0">
          <v-col
            cols="6"
            class="px-1"
          >
            <v-btn
              color="primary"
              class="mr-0"
              :loading="isLoading"
              @click="create"
            >
              {{ $t('submit') }}
            </v-btn>
          </v-col>
          <v-col
            cols="6"
            class="px-2"
          >
            <v-btn
              color="grey"
              outlined
              class="float-left"
              @click="$emit('close')"
            >
              {{ $t('cancel') }}
            </v-btn>
          </v-col>
        </v-row>
      </v-card-actions>
    </v-form>
    <v-snackbar
      v-model="snakbar"
      :color="(snakbarColor ? snakbarColor : 'primary')"
      top
      style="z-index: 1000000000000 !important;"
    >
      {{ snakbarText }}

      <template v-slot:action="{ attrs }">
        <v-btn
          color="white"
          text
          v-bind="attrs"
          @click="snakbar = !snakbar"
        >
          {{ $t('close') }}
        </v-btn>
      </template>
    </v-snackbar>
  </v-card>
</template>

<script>
  // import aicomplete from '../../components/general/AIcomplete/index'
  import General from '../../../../../Mixins/general'
  import autocomplete from '../../../components/general/patial/autocomplete'
  export default {
    name: 'Customer',
    components: {
      autocomplete,
    },
    mixins: [General],
    data: () => ({
      valid: true,
      apiKey: null,
      paymentZibalApiKey: null,
      paymentZibalBank: null,
      paymentZibalSystem: null,
      paymentZibalAccountName: null,
      paymentZibalAccountShaba: null,
      paymentZibalConfirm: false,
      select: 'zibal',
      render: false,
      isLoading: false,
    }),
    watch: {
    },
    activated () {
      this.show()
    },
    beforeMount () {
      this.statusItems = [
        {
          value: 'not_completed',
          text: this.$t('not_completed'),
        },
        {
          value: 'canceled',
          text: this.$t('canceled'),
        },
        {
          value: 'not_completed',
          text: this.$t('not_completed'),
        },
        {
          value: 'unfulfilled',
          text: this.$t('unfulfilled'),
        },
        {
          value: 'fulfilled',
          text: this.$t('fulfilled'),
        },
      ]
    },
    mounted () {
      this.show()
    },
    methods: {
      addPaymentMethod () {
        this.paymentItems.push({
          bank: null,
          value: null,
        })
      },
      remove (index) {
        this.paymentItems.splice(index, 1)
      },
      create () {
        if (!this.$refs.form.validate()) return false
        var app = this
        app.isLoading = true
        app.$axios.post(this.$endpoint + 'setting', this.$data)
          .then(res => {
            app.snakbarText = app.$t('registered')
            app.snakbarColor = 'green'
            app.snakbar = true
          })
          .catch(err => {
            this.serverErrorHandeler(err)
          })
          .finally(() => {
            this.isLoading = false
          })
      },
      show () {
        var app = this
        app.loading = true
        app.$axios.get(this.$endpoint + 'setting/' + 1 + '/edit', {
          params: {
            select: app.select,
          },
        })
          .then(res => {
            app.$nextTick(() => {
              res = res.data
              app.paymentZibalApiKey = res.paymentZibalApiKey
              app.paymentZibalSystem = res.paymentZibalSystem
              app.paymentZibalAccountName = res.paymentZibalAccountName
              app.paymentZibalAccountShaba = res.paymentZibalAccountShaba
              app.paymentZibalBank = res.paymentZibalBank
              app.paymentZibalConfirm = res.paymentZibalConfirm
              app.render = true
            })
          })
          .catch(err => {
            this.serverErrorHandeler(err)
          })
          .finally(() => (app.loading = false))
      },
      copied () {
        this.snakbarText = this.$t('copied')
        this.snakbarColor = 'blue'
        this.snakbar = true
      },
    },
  }
</script>

<style scoped>
.col{
  height: 55px !important;
}
</style>
